import NavBarCRM from "./ui/NavBar/NavBarCRM.vue";
import MessageNav from "./ui/MessageNav/MessageNav.vue";
import MessageDialog from "./ui/MessageDialog/MessageDialog.vue";
import MessageCenter from "./ui/MessageCenter/MessageCenter.vue";
import BreadCrumb from "./ui/BreadCrumb/BreadCrumb.vue";
import DescText from "./ui/DescText/DescText.vue";
import FontTip from "./ui/FontTip/FontTip.vue";
import DateShortCut from "./ui/DateShortCut/DateShortCut.vue";
import AgencyTree from "./ui/AgencyTree/AgencyTree.vue";
import Collapse from './ui/Collapse/Collapse.vue';
import IndicatorDescription from "./ui/IndicatorDescription/IndicatorDescription";
import LoginGuide from './ui/LoginGuide/LoginGuide.vue';
import AgreementSign from './ui/AgreementSign/Protocol';

import * as posVersionMethods from "./utils/posVersion";
import * as staticAssetsMethods from "./utils/staticAssets";

export const registerComponent = (Vue) => {
  Vue.component('navbar-e', NavBarCRM);
  Vue.component('comp-navbar-e', NavBarCRM);
  Vue.component('comp-message-nav', MessageNav);
  Vue.component('comp-message-dialog', MessageDialog);
  Vue.component('comp-message-center', MessageCenter);
  Vue.component('comp-bread-crumb', BreadCrumb);
  Vue.component('comp-desc-text', DescText);
  Vue.component('comp-font-tip', FontTip);
  Vue.component('comp-date-short-cut', DateShortCut);
  Vue.component('comp-agency-tree', AgencyTree);
  Vue.component('comp-collapse', Collapse);
  Vue.component('comp-indicator-description', IndicatorDescription);
  Vue.component('comp-login-guide', LoginGuide);
  Vue.component('comp-protocol', AgreementSign);

  //注册公用方法
  Vue.prototype.$posUtils = {};
  Object.keys(posVersionMethods).forEach((method) => {
    Vue.prototype.$posUtils[method] = posVersionMethods[method].bind(Vue.prototype);
  });

  //注册获取静态资源的方法
  Vue.prototype.$staticUtils = {};
  Object.keys(staticAssetsMethods).forEach((method) => {
    Vue.prototype.$staticUtils[method] = staticAssetsMethods[method].bind(Vue.prototype);
  });
};



// WEBPACK FOOTER //
// ./src/index.js